import React from 'react';
import PropTypes from 'prop-types';
import localeEs from 'date-fns/locale/es';
import { format } from 'date-fns';

/**
 * Styles
 */
import { StyledCalendarEventHour } from './style';

import {
  FormEvent,
  DivFlex,
  DivScroll,
  DivCenter,
  IconsEvent,
  IconEventClose,
  StrongMedium,
  DayMonthEvent,
  TitleEvent,
  ElementEvent,
  DateEvent,
  DateRange,
  LinksEvent,
  LinkNews,
  WrapperButtons,
  EventButton,
  EventButtonInvested
} from './styleCaledarEventHour';

/**
 * Images
 */
import { Close, Diary, Reloj, DirGeo, Clip } from '../../../../assets/images';

const CalendarEventHour = ({
  className,
  rejectedEvent,
  acceptedEvent,
  dataEvent
}) => (
  <StyledCalendarEventHour className={className}>
    <FormEvent action="#" method="post">
      <IconEventClose svg={Close} color="dark" size="m" />
      <DivCenter>
        <DivFlex>
          <IconsEvent svg={Diary} hover={false} size="m" color="dark" />
          <DayMonthEvent date={dataEvent.eventDate} dayNumber month dayText />
        </DivFlex>
        <TitleEvent>{dataEvent.eventName}</TitleEvent>
        <DivScroll>
          {dataEvent.eventConvener && (
            <ElementEvent>
              <span>Convoca:</span>
              &nbsp;
              <strong>{dataEvent.eventConvener}</strong>
            </ElementEvent>
          )}
          <DateEvent>
            <IconsEvent svg={Reloj} hover={false} size="m" color="dark" />
            <span>
              {dataEvent.eventDays &&
                dataEvent.eventDays.map(item => (
                  <DateRange dateTime={format(item.eventDay, 'YYYY-MM-DD')}>
                    <StrongMedium>
                      {format(item.eventDay, 'DD MMMM', {
                        locale: localeEs
                      })}
                      : {item.eventHour}
                    </StrongMedium>
                  </DateRange>
                ))}
            </span>
          </DateEvent>
          <ElementEvent>
            <IconsEvent svg={DirGeo} hover={false} size="m" color="dark" />
            <span>{dataEvent.eventLocation}</span>
          </ElementEvent>
          <ElementEvent>
            <IconsEvent svg={Clip} hover={false} size="m" color="dark" />
            <LinksEvent href={`documento/${dataEvent.docEvent}`}>
              {dataEvent.docEvent}
            </LinksEvent>
          </ElementEvent>
          <ElementEvent>{dataEvent.descriptionEvent}</ElementEvent>
          {dataEvent.linkNews !== '' && (
            <ElementEvent>
              <LinkNews href={dataEvent.linkNews}>+ Ir a noticia</LinkNews>
            </ElementEvent>
          )}
        </DivScroll>
        <WrapperButtons>
          <EventButtonInvested
            dark
            rejectedEvent={rejectedEvent}
            type="submit"
            name="rejectEvent"
          >
            {rejectedEvent ? `Rechazado` : `Rechazar`}
          </EventButtonInvested>
          <EventButton
            dark
            acceptedEvent={acceptedEvent}
            type="submit"
            name="acceptEvent"
          >
            {acceptedEvent ? `Aceptado` : `Aceptar`}
          </EventButton>
        </WrapperButtons>
      </DivCenter>
    </FormEvent>
  </StyledCalendarEventHour>
);

CalendarEventHour.propTypes = {
  className: PropTypes.string,
  rejectedEvent: PropTypes.bool,
  acceptedEvent: PropTypes.bool,
  dataEvent: PropTypes.shape({
    eventName: PropTypes.string,
    eventDate: PropTypes.string,
    eventConvener: PropTypes.string,
    eventLocation: PropTypes.string,
    docEvent: PropTypes.string,
    type: PropTypes.string,
    descriptionEvent: PropTypes.string,
    eventDays: PropTypes.arrayOf(
      PropTypes.shape({
        eventDay: PropTypes.string,
        eventHour: PropTypes.string
      })
    )
  }).isRequired
};

export default CalendarEventHour;
